import { ReactNode, useState } from 'react';
import ErrorFallback from '../components/errorFallback';
import LoadingFallback from '../components/loadingFallback';

export default function useRequestState<TReturn>() {
  const [data, setData] = useState<TReturn | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const handleRequest = async (
    asyncPromise: Promise<TReturn>,
  ) => {
    try {
      setLoading(true);
      setError(null);

      const response = await asyncPromise;

      if (response !== undefined && response !== null) {
        setData(response);
      }

      return response;
    } catch (err) {
      if (err instanceof Error) {
        setError(err);
      }

      if (err && typeof err === 'object' && 'detail' in err) {
        if (typeof err.detail === 'string') {
          setError(new Error(err.detail));
        }
      }
      return null;
    } finally {
      setLoading(false);
    }
  };
  function FallbackWrapper({
    children,
    loadingMessage,
  }: Readonly<{
    children: ReactNode;
    loadingMessage: string;
  }>) {
    return (
      <>
        {loading && <LoadingFallback message={loadingMessage} />}
        {!loading && error ? <ErrorFallback errorMessage={error} /> : ''}
        {!loading && !error ? children : ''}
      </>
    );
  }

  return {
    data,
    loading,
    error,
    handleRequest,
    FallbackWrapper,
  };
}
